import { useTheme } from '@mui/material/styles'

export function useDisabledOpacity(disabled?: boolean): number {
    const theme = useTheme()
    const { disabledOpacity } = theme.palette.action

    return disabled ? disabledOpacity : 1
}
